import { useQuery } from '@tanstack/react-query';

import { getOrder } from '~/services/OrdersService';

const BEDBANK_JOBS_POLL_INTERVAL_MS = 60_000;

export const orderQueryKeys = {
  all: ['order'] as const,
  details: () => [...orderQueryKeys.all, 'detail'] as const,
  detail: (orderId: string) => [...orderQueryKeys.details(), orderId] as const,
};

export type UseGetOrderOptions = {
  enabled?: boolean;
  pollWhileBedbankProcessing?: boolean;
};

export function useGetOrder(orderId: string, options: UseGetOrderOptions = {}) {
  const { enabled = true, pollWhileBedbankProcessing = false } = options;
  const shouldPollWhileBedbankProcessing = pollWhileBedbankProcessing && enabled;

  return useQuery({
    queryKey: orderQueryKeys.detail(orderId),
    queryFn: async ({ signal }) => getOrder(orderId, { signal }),
    enabled: !!orderId && enabled,
    staleTime: shouldPollWhileBedbankProcessing ? 0 : 60_000,
    refetchOnMount: shouldPollWhileBedbankProcessing ? 'always' : undefined,
    refetchInterval: shouldPollWhileBedbankProcessing
      ? (query) => {
          if (!query.state.data) {
            return BEDBANK_JOBS_POLL_INTERVAL_MS;
          }

          const hasProcessingItem = query.state.data?.result?.bedbank_items?.some((item) => item.processing);
          return hasProcessingItem ? BEDBANK_JOBS_POLL_INTERVAL_MS : false;
        }
      : false,
    refetchIntervalInBackground: false,
    retry: false,
  });
}
